module.exports = __webpack_public_path__ + "img/30.720c5709.png";